import { GET_ADMIN_DASHBOARD_DATA_RESPONSE } from "./actionTypes";

import produce from "immer";

export const initialState = {
  dashboardApiResponse: null,
};

const dashboard = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case GET_ADMIN_DASHBOARD_DATA_RESPONSE:
        draft.dashboardApiResponse = action.payload.apiResponse;
        break;

      default:
        state = { ...state };
        break;
    }
  });

export default dashboard;
